import { render, staticRenderFns } from "./BiddersList.vue?vue&type=template&id=69ecb78b&scoped=true"
import script from "./BiddersList.vue?vue&type=script&lang=js"
export * from "./BiddersList.vue?vue&type=script&lang=js"
import style0 from "./BiddersList.vue?vue&type=style&index=0&id=69ecb78b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ecb78b",
  null
  
)

export default component.exports